export default __webpack_public_path__ + "static/media/envelope.950357e7.svg";